/**
 * Auth utility functions
 */

import jwtDecode from 'jwt-decode';

/**
 * Check if a token is valid
 * @param {string} token - JWT token
 * @returns {boolean} - True if token is valid and not expired
 */
export function isValidToken(token) {
  if (!token) return false;

  try {
    const decoded = jwtDecode(token);
    const currentTime = Date.now() / 1000;

    // Check if token is expired
    return decoded.exp > currentTime;
  } catch (error) {
    console.error('Invalid token format:', error);
    return false;
  }
}

/**
 * Check if token is about to expire
 * @param {string} token - JWT token
 * @param {number} thresholdMinutes - Minutes threshold before expiration
 * @returns {boolean} - True if token will expire within threshold
 */
export function isTokenExpiringSoon(token, thresholdMinutes = 5) {
  if (!token) return false;

  try {
    const decoded = jwtDecode(token);
    const currentTime = Date.now() / 1000;
    const thresholdSeconds = thresholdMinutes * 60;

    // Check if token will expire within threshold
    return decoded.exp < currentTime + thresholdSeconds;
  } catch (error) {
    console.error('Invalid token format:', error);
    return false;
  }
}
